// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { MultiSocketEndpoint } from "@lib/messaging/MultiSocketEndpoint";
import { NetworkNode } from "@lib/messaging/NetworkNode";
import { SingleSocketEndpoint } from "@lib/messaging/SingleSocketEndpoint";
import { Socket } from "@lib/messaging/Socket";

/**
 * Describes the source of a raw message.
 * Used to handle incoming raw messages in the `MessageServer`.
 */
export type RawMessageSource = {
  endpoint: SingleSocketEndpoint;
  node: NetworkNode;
  socket: Socket;
} | {
  endpoint: MultiSocketEndpoint;
  node: NetworkNode;
  socket: Socket;
  socketID: string;
};